/* eslint-disable unused-imports/no-unused-vars */
/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/landing_page_stats/:landing_page_id" endpoint
 */

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageStatsLandingPageBsonId } from "./constants";
import type { EngagementLandingPageStatsResult } from "./types";
import { isEngagementLandingPageStatsResult } from "./validators";

// This endpoint exists but returns static data
export const getEngagementLandingPageStats = reactQueryFetcherAdapter(
  engagementLandingPageStatsLandingPageBsonId,
  (
    signal: AbortSignal,
    landingPageId: string,
    appGroupId: string,
    start: number,
    end: number
  ): Promise<EngagementLandingPageStatsResult> => {
    return fetch(
      `/engagement/landing_pages/${appGroupId}/landing_page_stats/${landingPageId}`,
      "GET",
      { start_date: start, end_date: end },
      { signal }
    );
  },
  isEngagementLandingPageStatsResult
);
